// src/components/ui/TestimonialCard.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin, Briefcase } from 'lucide-react';
import { fadeInUp } from '../../utils/animations';

interface TestimonialCardProps {
  testimonial: {
    name: string;
    location: string;
    text: string;
    rating: number;
    profession?: string;
  };
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  return (
    <motion.div
      variants={fadeInUp}
      className="bg-white rounded-2xl shadow-lg p-6 border border-mauve-100 hover:shadow-xl transition-shadow duration-300"
    >
      {/* Rating */}
      <div className="flex mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={18}
            className={`${
              i < testimonial.rating
                ? 'fill-mauve-500 text-mauve-500'
                : 'text-mauve-200'
            }`}
          />
        ))}
      </div>
      
      {/* Testimonial Text */}
      <p className="text-mauve-700 mb-6 italic">"{testimonial.text}"</p>
      
      {/* Client Info */}
      <div className="pt-4 border-t border-mauve-100">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-bold text-mauve-900">{testimonial.name}</h4>
            <div className="flex items-center text-mauve-600 text-sm mt-1">
              <MapPin size={14} className="mr-1" />
              <span>{testimonial.location}</span>
            </div>
          </div>
          
          {testimonial.profession && (
            <div className="flex items-center text-mauve-600 text-sm">
              <Briefcase size={14} className="mr-1" />
              <span>{testimonial.profession}</span>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;